import s from "./Iframe.module.scss"

// The iframe that we use to embed most of our products in Portal

type IframeProps = {
  src?: string | undefined
  permissions?: string[]
}
export const Iframe = ({ src, permissions = [] }: IframeProps) => {
  const allow = [
    /**
     * "autoplay" is currently explicitly disabled.
     * Some browsers/devices (e.g. iOS) do not support autoplay
     * and cause the video to go into a fake "infinite buffering"
     * state until explicit user action.
     *
     * https://help.vimeo.com/hc/en-us/articles/29677068222737-Troubleshooting-Autoplay-restrictions
     */
    // "autoplay",

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
     */
    "encrypted-media",

    /**
     * Additional Permissions Policy directives to be allowed in the iframe.
     * https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Permissions-Policy#directives
     */
    ...permissions,
  ].join("; ")

  return (
    <iframe
      className={s.iframe}
      src={src}
      title="Attensi product viewer"
      allow={allow}
      allowFullScreen
    />
  )
}
